module.exports = __webpack_public_path__ + "img/solution-v2x-system-pic-01.16e48c70.png";